import { IAuditService, IUserNavigation } from "@/services/audit/audit.types";
import { Vue } from "vue-property-decorator";
import { BACKEND_BASE_URL } from "@/services";

export class AuditService implements IAuditService {
  async saveUserNavigation(soConfColumnasUpdateDTO: IUserNavigation): Promise<void> {
    const headers = {
      Accept: "application/json",
    };

    Vue.$axios.post(`${BACKEND_BASE_URL}/api/audit/user-navigation`, soConfColumnasUpdateDTO, {
      headers,
    });
  }
}
